<div class="custom-row">
  @if(mode==="read" && leadStatus !== approvedStatus){
    <!-- <span (click)="editInfo()" nz-icon nzType="edit" nzTheme="outline"></span> -->
    <ppl-button 
    label="Edit" 
    icon="fa fa-pencil" 
    [customClass]="'ghost-button'" 
    [iconPosition]="'left'"
    (click)="editInfo()"
    ></ppl-button> 
  }
  
</div>

<!-- Edit Mode -->
@if(mode==="edit"){ 
  <form nz-form [formGroup]="servicesForm" class="ppl-p0">
    <nz-form-item class="ppl-form-item">
      <nz-form-label nzSpan="4" nzFor="profLicences" class="ppl-form-label">
        {{getAttributes('profLicences').label}}
        @if(getAttributes('profLicences').mandatory === 'Y'){
          <span>*</span>
        }
      </nz-form-label>
      <nz-form-control nzSpan="8">
        <div nz-tooltip [nzTooltipTitle]="getAttributes('profLicences')?.tooltip || ''" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['profLicences'] }">
            <ppl-multiselect formControlName="profLicences" id="profLicences" [options]="licences" style="width:100%; margin-bottom: 16px"
              [showClear]="true" placeholder="{{getAttributes('profLicences').placeholder}}" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'" [disabled]="false" [maxTagCount]="4" style="width:100%; margin-bottom: 16px">
            </ppl-multiselect>
          </div>
        </div>
        @if (validationErrors['profLicences']) {
          <span class="pl-1 error-message">{{validationErrors['profLicences']}}</span>
        }
      </nz-form-control>
    </nz-form-item>
  </form>
  <div  class="custom-row">
    <ppl-button 
    label="Cancel" 
    icon="fa fa-ban" 
    [customClass]="'alt-button'" 
    [iconPosition]="'left'"
    (click)="cancelEdit()"
    ></ppl-button>    

    <ppl-button 
    label="Save" 
    icon="fa fa-floppy-o" 
    [customClass]="'alt-button'" 
    [iconPosition]="'left'"
    (click)="save()"
    ></ppl-button>
  </div>
}

<!-- Read Mode -->
@else if(mode==="read" && secData){
  @if(isAttrAvailable('profLicences') && filledInfo){
    <div nz-row>
      <div nz-col nzSpan="4" class="ppl-read-label">{{getAttributes('profLicences').label}}</div>
      <div nz-col>
        @for (file of filledInfo; track $index) {
          {{getLookupValue(licences, file.licenseType)}}@if(!$last){, }       
        }
      </div>
    </div>
  }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
  }
}